import React from "react";
import styles from "../styles/modules/Loading.module.css";

const LoadingOverlay: React.FC = () => {
  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <div className={styles.spinner} />
      <span className={styles.label}>読み込み中…</span>
    </div>
  );
};

export default LoadingOverlay;
